const modalSupportTypo = {
  isNewDataTrue: 'Cadastrar Novo Arquivo de Apoio',
  isNewDataFalse: 'Editar Arquivo de Apoio'
};

export default modalSupportTypo;
